import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('clusters', function () {
    this.route('new');
    this.route('list');
    this.route('cluster', {
      path: '/:id'
    }, function () {
      this.route('detail', function () {
        this.mount('monitoring', {
          path: 'monitoring'
        });
        this.route('edit-configuration');
        this.route('guided-onboarding');
      });
    });
  });
});